import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const liability_family = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('family_coverage')]:
        BaseSchema_LiabilityV1GetsafeDe.shape.family_coverage,
    }),
    stepContent: [
      {
        type: 'title',
        text: { type: 'translatableText', translationKey: 'sharedFlows_common:steps.family.title' },
        infoButton: {
          modalConfiguration: [
            {
              type: 'text',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_liabilityNxt:steps.liability.family.info.text',
              },
            },
          ],
        },
      },
      {
        type: 'choice',
        name: params.helperFunctions.getParamPath('family_coverage'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_liabilityNxt:steps.liability.family.me',
            },
            value: false,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_liabilityNxt:steps.liability.family.all',
            },
            value: true,
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'liability_zip',
  }) as const satisfies AnyStepConfiguration

export default liability_family
